import { render, staticRenderFns } from "./BaseFilesDropzone.vue?vue&type=template&id=71a0dc2a&scoped=true&"
import script from "./BaseFilesDropzone.vue?vue&type=script&lang=js&"
export * from "./BaseFilesDropzone.vue?vue&type=script&lang=js&"
import style0 from "./BaseFilesDropzone.vue?vue&type=style&index=0&id=71a0dc2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a0dc2a",
  null
  
)

export default component.exports